import React from "react"

import OuterLengthConfigurationInput from "components/Configurations/OuterLengthConfigurationInput"

import {
	DispatchProductDetailPageReducer,
	ProductDetailPageReducerState,
	setSelectedOuterLength,
} from "@secureo/common/reducers/productDetailPageReducer"

const OuterLengthConfiguration = ({ isLoading, dispatch, reducerState, accessToken }: Props) => {
	const {
		selectedOuterLength,
		attributes: { outerLengths },
	} = reducerState

	const onOuterLengthChange = (selectedOuterLength: number) => {
		setSelectedOuterLength(accessToken, dispatch, reducerState, selectedOuterLength)
	}

	return (
		<OuterLengthConfigurationInput
			outerLengths={outerLengths}
			selectedOuterLength={selectedOuterLength}
			onOuterLengthChange={onOuterLengthChange}
			showMeasureCylinderDialog
			disabled={isLoading || !accessToken}
		/>
	)
}

interface Props {
	isLoading: boolean
	dispatch: DispatchProductDetailPageReducer
	reducerState: ProductDetailPageReducerState
	accessToken: string
}

export default OuterLengthConfiguration
